module.exports = __webpack_public_path__ + "img/face2.95340797.jpg";